import formatDate, { formatToDateTime } from '@functions/formatDate'

const mapProviderToModel = (provider = {}) => ({
  ...provider,
  bank_account_bsb: provider.bank_account?.bsb,
  bank_account_name: provider.bank_account?.name,
  bank_account_number: provider.bank_account?.number,
  billing_start_date: formatDate(provider.billing_start_date, 'dd/MM/yyyy'),
  last_billed_at: formatToDateTime(provider.last_billed_at),
})

export default mapProviderToModel
